import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';


export interface DashboardEquipmentsData {
  accountMaintenancesStatistics: {
    reportName: string;
    items: {
      key: string;
      value: number;
    }[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class QueryDashboardEquipmentsDataGQL extends Query<DashboardEquipmentsData> {
  document = gql`
    query QueryDashboardEquipmentsDataGQL($where: DashboardInput!){
      accountMaintenancesStatistics(where: $where) {
        reportName
        items {
          key
          value
        }
      }
    }
  `;
}
